import React, { useRef, useEffect } from "react";
import { SelfieSegmentation } from "@mediapipe/selfie_segmentation";
import { Camera } from "@mediapipe/camera_utils";

const VirtualBackgroundOverlay = ({ videoRef }) => {
  const canvasRef = useRef(null);
  const cameraRef = useRef(null);

  useEffect(() => {
    if (!videoRef.current) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    const selfieSeg = new SelfieSegmentation({
      locateFile: (file) =>
        `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/${file}`,
    });

    selfieSeg.setOptions({ modelSelection: 1 });

    selfieSeg.onResults((results) => {
      const video = videoRef.current;
      if (!video || video.videoWidth === 0 || video.videoHeight === 0) return;

      // Always match the real video size
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Step 1: Draw the mask
      ctx.drawImage(results.segmentationMask, 0, 0, canvas.width, canvas.height);

      // Step 2: Use mask to show only person
      ctx.globalCompositeOperation = "source-in";
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

      // Reset blend mode
      ctx.globalCompositeOperation = "source-over";
    });

    cameraRef.current = new Camera(videoRef.current, {
      onFrame: async () => {
        const video = videoRef.current;
        if (!video || video.videoWidth === 0 || video.videoHeight === 0) return;
        await selfieSeg.send({ image: video });
      },
      width: 640,
      height: 480,
    });

    cameraRef.current.start();

    return () => cameraRef.current?.stop();
  }, [videoRef]);

  return (
    <canvas
      ref={canvasRef}
      className="bg-removed-canvas"
    />
  );
};

export default VirtualBackgroundOverlay;
